// needed to support 'react-markdown' compilation with esbuild
// https://github.com/evanw/esbuild/issues/85#issuecomment-624346338
import process from 'process';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactMarkdown from 'react-markdown';

import getMarkdownRenderers from '../helpers/getMarkdownRenderers';
import getMarkdownTransform from '../helpers/getMarkdownTransform';

import styles from '../styles/uikitContentMarkdown.module.scss';

window.process = process;

const Markdown = ({
  content,
  className = '',
  customRenderers = {},
  getLinkPreviewData = () => {},
  isReviewing = false,
  LinkPreview = null,
  linkPreviewContentAlignment = 'topLeft',
  linkPreviewHrefPrefix = '/student/activity/',
  linkTarget = '_blank',
  onMentionClicked = () => {},
  onHashtagClicked = () => {},
  onLinkClicked = () => {},
  shouldEscapeHtml = false,
  shouldTruncateLink = false,
}) => {
  const markdownRenderers = getMarkdownRenderers({
    shouldTruncateLink,
    isReviewing,
    onMentionClicked,
    onHashtagClicked,
    onLinkClicked,
    getLinkPreviewData,
    LinkPreview,
    linkPreviewHrefPrefix,
    linkPreviewContentAlignment,
    linkTarget,
    customRenderers,
  });

  const source = getMarkdownTransform(content);

  return (
    <ReactMarkdown
      className={classnames(styles.element, className)}
      source={source}
      linkTarget={linkTarget}
      renderers={markdownRenderers}
      escapeHtml={shouldEscapeHtml}
    />
  );
};

Markdown.propTypes = {
  content: PropTypes.string.isRequired,
  className: PropTypes.string,
  customRenderers: PropTypes.shape({}),
  onMentionClicked: PropTypes.func,
  onHashtagClicked: PropTypes.func,
  onLinkClicked: PropTypes.func,
  getLinkPreviewData: PropTypes.func,
  LinkPreview: PropTypes.elementType,
  linkPreviewHrefPrefix: PropTypes.string,
  linkPreviewContentAlignment: PropTypes.oneOf([
    'topLeft',
    'bottomLeft',
    'topCenter',
    'bottomCenter',
    'topRight',
    'bottomRight',
  ]),
  linkTarget: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
  isReviewing: PropTypes.bool,
  shouldEscapeHtml: PropTypes.bool,
  shouldTruncateLink: PropTypes.bool,
};

export default React.memo(Markdown);
